var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNp(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    width: 41,
    height: 40,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.7 0h40v40H.7z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ce0000",
    stroke: "#000063",
    strokeWidth: 1.6,
    d: "M1.2 39.5h29.6L11.4 19.9h20.1L1.2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m14.8 29-2.1.8 1.6 1.5-2.2-.1 1 2-2-1v2.3l-1.5-1.7-.8 2.1-.8-2-1.5 1.6.1-2.2-2.1.9 1-2-2.3.1 1.7-1.4-2.2-.9 2.1-.7-1.6-1.5 2.2.1-1-2 2 1v-2.3L8 25.2l.9-2 .7 2 1.6-1.6-.2 2.2 2.1-1-1 2h2.3l-1.6 1.4zm-2.5-14.4-1 .7.5.3q1.6-1.1 2.4-2.8c.1 1.7-1.4 5.4-5.4 5.4a5.5 5.5 0 0 1-5.5-5.4c.7 1.4 1.2 2 2.5 2.8l.3-.3-.8-.7 1-.3-.5-1 1.1.1-.1-1.1 1 .6.3-1.1.7.8.6-.8.4 1.1 1-.6-.2 1.1 1.1-.1-.5 1z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.7 0H54v40H.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNp);
export default __webpack_public_path__ + "static/media/np.64548e65553015e27dcacfe5fc4d49aa.svg";
export { ForwardRef as ReactComponent };